// extracted by mini-css-extract-plugin
export var borderRadius = "_ac-4";
export var large = "_ac-3";
export var logoContainer = "_ac-0";
export var nameLogo = "_ac-2";
export var small = "_ac-1";